<script>
import { BModal, BFormTextarea, } from 'bootstrap-vue'
import Button from "@core/components/common/Button.vue";
import EmailAttachments from "@/views/supply-chain/supplier/EmailAttachments.vue";

export default {
    components: {BModal, BFormTextarea, Button, EmailAttachments},
    props: {
        record: {
            type: Object,
            default() {
                return {
                    note: '',
                    attributes: {}
                };
            }
        },
        showReplyButton: {
            default: false
        },
        html: {
            default: false
        }
    },
    methods: {
        show() {
            this.$refs.emailModal.show();
        },
        hide() {
            this.$refs.emailModal.hide();
        },
        reply() {
            this.$emit('reply', this.record);
        }
    },
}
</script>

<template>
    <b-modal
        ref="emailModal"
        cancel-variant="outline-secondary"
        :ok-title="$t('Component(Button):close')"
        :title="$t('Page(SendRequest):Component(Label):email-message')"
        @ok="hide"
        ok-only
        size="xl"
        centered
        no-close-on-backdrop
    >
        <span v-if="html" v-html="record ? record.note : ''"/>
        <pre v-else class="p-1">{{ record ? record.note : '' }}</pre>

        <EmailAttachments
            :attachments="record && record.attributes ? record.attributes.attachments : []"
            @download="(attachment) => $emit('download', attachment)"
            @view="(attachment) => $emit('view', attachment)"
        />

        <template #modal-footer="data">
            <Button v-if="showReplyButton" @click="reply">{{ $t('Component(Button):reply') }}</Button>
            <Button @click="hide">{{ $t('Component(Button):close') }}</Button>
        </template>
    </b-modal>
</template>
